module.exports = __webpack_public_path__ + "img/square-table-8.c5feed2d.png";